module.exports = __webpack_public_path__ + "media/images/peb/8mm/peb_b-0ad57cd90e90f3aff695cc5c23e4c86b.png";